class ProductEditingService extends BaseService
	@register()
	@inject 'ProductService',
		'MessageTerminal'
		'ProductStockEditingService'
		'ProductImagesRepository'
		'ProductRepository'
		'BACKEND_PRODUCT_ENTITY_TYPE'

	saveEntity: (ProductController) ->
		@controller = ProductController

		productToSave = @getProductForSaving()

		if @controller.stocksEnabled && @isBaseProduct()
			return @saveProduct(productToSave)
				.then (response) =>
					@ProductStockEditingService
						.saveStockEvents(@controller)
						.then =>
							@ProductStockEditingService
								.saveStockValues(@controller)
								.then =>
									@resetProductVariants()
									@resetStockValues()

									return response
		else
			return @saveProduct(productToSave)

	resetProductVariants: ->
		for variant in @controller.product.product_variants
			variant.is_new = false

	resetStockValues: ->
		@controller.stockValuesToRemove = []

		_.map @controller.product.stock_values, (stockValue) => @resetStockValue(stockValue)

		angular.forEach @controller.product.product_variants, (variant) =>
			_.map variant.stock_values, (stockValue) => @resetStockValue(stockValue)

	resetStockValue: (stockValue) ->
		stockValue.quantity = (parseFloat(stockValue.quantity || 0) + parseFloat(stockValue.delta_quantity || 0)).toFixed(3)
		stockValue.delta_quantity = (0).toFixed(3)
		stockValue.reason_code_id = null
		stockValue.possibleReasonCodes = _.clone @controller.reasonCodes
		stockValue.isNew = false

	isBaseProduct: ->
		return !@controller.isBundleProduct() &&
			!@controller.isAddonProduct() &&
			!@controller.isDepositProduct() &&
			!@controller.isNonStockProduct()

	saveProduct: (productToSave) ->
		return @ProductRepository
			.saveWithAttachment productToSave, @controller.mainCrud.isNewEntity
			.then (response) =>
				@saveProductImages(response.data.id)

				@updateKeysForProduct(response.data)
				@controller.product.image = response.data.image
				@controller.product.addon_products = response.data.addon_products
				@controller.product.bundled_products = response.data.bundled_products
				@controller.product.product_filters = @controller.mapProductFilterNames(response.data.product_filters)
				@controller.product.product_data = response.data.product_data
				@controller.product.id = response.data.id
				@controller.initBundleProducts()

				return response

	saveProductImages: (productId) ->
		for deletedImageId in @controller.deletedImagesIds
			@ProductImagesRepository.delete deletedImageId

		for image in @controller.product.product_images
			if image.image? and (image.is_new or image.is_changed)
				imageFile = image.image
				imageCopy = angular.copy image
				imageCopy.image = imageFile
				imageCopy.product_id = productId

				whitelistAttribute = [
					'id'
					'name'
					'order'
					'image'
					'product_id'
				]

				for own key of imageCopy
					if !whitelistAttribute.includes(key)
						delete imageCopy[key]

				@ProductImagesRepository.saveWithAttachment(imageCopy, image.is_new == true)
		@MessageTerminal.publish @MessageTerminal.events.GALLERY.AFTER_SAVE
		@controller.deletedImagesIds = []

	# Updates product and its variants keys after save
	# Sets primary and relational key properties with the data from `savedProduct`
	updateKeysForProduct: (savedProduct) ->
		@controller.product.id = savedProduct.id

		angular.forEach @controller.product.stock_values, (stockValue) =>
			stockValue.product_id = savedProduct.id

		angular.forEach @controller.product.product_variants, (variant) =>
			savedVariant = _.findWhere(savedProduct.product_variants, {id: variant.id})

			if savedVariant?
				variant.id = savedVariant.id
				variant.product_id = savedProduct.id

				angular.forEach variant.stock_values, (variantStockValue) =>
					variantStockValue.product_id = savedProduct.id
					variantStockValue.product_variant_id = savedVariant.id

	getProductForSaving: ->
		@processProductUnitDataBeforeSave(@controller.attributesService)
		@controller.attributesService.persistAttributes()
		imageCopy = @controller.product.image

		if @controller.isBundleProduct() || @controller.isAddonProduct() || @controller.isDepositProduct()
			@controller.product.stock_values = []

		if @controller.isBundleProduct() || @controller.isDepositProduct()
			@controller.product.product_variants = []

		@processProductData @controller.product, @controller.hasVariablePrice, @controller.unitId

		if @controller.product.product_variants.length
			for variant in @controller.product.product_variants
				variant.attributeService.persistAttributes()
				@processProductData variant, @controller.hasVariablePrice, @controller.unitId

		productCopy = angular.copy(@controller.product)
		productCopy.product_categories = _.pluck(productCopy.product_categories, 'id')
		productCopy.product_filters = _.map productCopy.product_filters, (productFilter) -> _.omit(productFilter, 'name')

		productCopy.shops = _.pluck(productCopy.shops, 'id')
		productCopy.shop_groups = _.pluck(productCopy.shop_groups, 'id')

		if productCopy.supplier?
			productCopy.supplier_id = productCopy.supplier.id
		else
			productCopy.supplier_id = null
			productCopy.supplier_reference_id = null

		if productCopy.deposit_product? && @controller.canHaveDepositProduct()
			productCopy.deposit_product_id = productCopy.deposit_product.id
		else
			productCopy.deposit_product_id = null

		if @controller.canHaveAddonProducts()
			productCopy.entity_type = @BACKEND_PRODUCT_ENTITY_TYPE.PRODUCT
			productCopy.addon_products = @prepareAddonProducts(productCopy.addon_products, productCopy)
			productCopy.bundled_products = []
		else if @controller.canHaveBundledProducts()
			productCopy.entity_type = @BACKEND_PRODUCT_ENTITY_TYPE.BUNDLE
			productCopy.addon_products = []
			productCopy.bundled_products = @prepareBundledProducts(productCopy.bundled_products)
			productCopy.min_addons_quantity = null
			productCopy.max_addons_quantity = null
		else if @controller.isNonStockProduct()
			delete productCopy.addon_products
			delete productCopy.product_variants
			delete productCopy.bundled_products
		else
			productCopy.entity_type ?= @BACKEND_PRODUCT_ENTITY_TYPE.PRODUCTS
			productCopy.addon_products = []
			productCopy.bundled_products = []
			productCopy.min_addons_quantity = null
			productCopy.max_addons_quantity = null

		if imageCopy?
			productCopy.image = imageCopy

		delete productCopy.stock_values
		delete productCopy.supplier
		delete productCopy.deposit_product
		delete productCopy.bundled_product_metadata

		# save it separately
		delete productCopy.product_images

		if !@controller.isNonStockProduct()
			if productCopy.product_variants?
				for variant, key in productCopy.product_variants
					if variant.supplier?
						variant.supplier_id = variant.supplier.id
					else
						variant.supplier_id = null
						variant.supplier_reference_id = null

					delete variant.supplier
					delete variant.stock_values

			@processVariantsUnitDataBeforeSave productCopy

		return productCopy

	processVariantsUnitDataBeforeSave: (productCopy) ->
		unitIdBase = @controller.attributesService.attributes.unit_id_base?.value
		removeAllUnitData = @shouldRemoveAllUnitData unitIdBase

		for variant in productCopy.product_variants
			removeVariantActualUnitData = removeAllUnitData ||
				@controller.unitId != 'pc' ||
				_.isEmpty(variant.attributeService.attributes.unit_id_actual?.value) ||
				variant.attributeService.attributes.unit_id_actual.value == '-1' ||
				!variant.attributeService.attributes.unit_amount?.value

			if removeVariantActualUnitData
				if variant.attributeService.hasAttribute 'unit_amount'
					variant.attributeService.attributes.unit_amount.value = null

				if variant.attributeService.hasAttribute 'unit_id_actual'
					variant.attributeService.attributes.unit_id_actual.value = null

			variant.attributeService.persistAttributes()
			delete variant.attributeService

	shouldRemoveAllUnitData: (unitIdBase) ->
		return @controller.isDepositProduct() || @controller.isBundleProduct() || _.isEmpty(unitIdBase) || unitIdBase == '-1'

	processProductData: (item, hasVariablePrice, unitId) ->
		for productDataItem in item.product_data
			productDataItem.variable_price = hasVariablePrice
			productDataItem.unit_id = unitId

			if @controller.isBundleProduct()
				productDataItem.vat_rate_id = null
				productDataItem.cost_price = null

	processProductUnitDataBeforeSave: ->
		if !@controller.isUnitPricingEnabled
			return

		unitIdBase = @controller.attributesService.attributes.unit_id_base?.value
		unitIdActual = @controller.attributesService.attributes.unit_id_actual?.value
		unitAmount = @controller.attributesService.attributes.unit_amount?.value

		removeAllUnitData = @shouldRemoveAllUnitData unitIdBase

		removeProductActualUnitData = removeAllUnitData ||
			_.isEmpty(unitIdActual) ||
			unitIdActual == '-1' ||
			unitAmount == 0 ||
			@controller.product.product_variants.length > 0

		if removeAllUnitData && @controller.attributesService.hasAttribute 'unit_id_base'
			# Direct value setting is used here instead of attributesService.removeAttribute() because remoteAttribute()
			# is async and the promise that it returns will not resolve until after product is already saved
			@controller.attributesService.attributes.unit_id_base.value = null

		if removeProductActualUnitData
			if @controller.attributesService.hasAttribute 'unit_amount'
				@controller.attributesService.attributes.unit_amount.value = null

			if @controller.attributesService.hasAttribute 'unit_id_actual'
				@controller.attributesService.attributes.unit_id_actual.value = null

	prepareAddonProducts: (addons) ->
		for addon in addons
			delete addon.id if addon.is_new
			delete addon.is_default
			delete addon.error
			delete addon.is_new

		return addons

	prepareBundledProducts: (bundledProducts) ->
		prepared = []

		for bundledProduct in bundledProducts
			delete bundledProduct.id if bundledProduct.is_new
			delete bundledProduct.error
			delete bundledProduct.is_new
			delete bundledProduct.name
			delete bundledProduct.product_variants

			key = bundledProduct.product_id + bundledProduct.product_variant_id
			bundledProduct.quantity = parseInt(bundledProduct.quantity)

			product = prepared[key]

			if (product)
				product.quantity += bundledProduct.quantity
			else
				product = bundledProduct

			prepared[key] = product

		return _.values(prepared)
